import { apiRequest, ApiResponse } from '../request'

export interface FinancialAssistantReply {
    conversationId: string
    reply: string
}

/**
 * Pergunta ao assistente financeiro. O histórico fica no servidor (Redis, 24h); o
 * front guarda só o `conversationId` para dar continuidade.
 */
export async function sendFinancialAssistantMessage(data: {
    message: string
    conversationId?: string
}): Promise<ApiResponse<FinancialAssistantReply>> {
    return apiRequest<FinancialAssistantReply>('financial/assistant/message', { data }, 'post')
}

/** Encerra a conversa atual no servidor e devolve uma nova, vazia. */
export async function resetFinancialAssistantConversation(
    conversationId?: string
): Promise<ApiResponse<{ conversationId: string; conversationReset: boolean }>> {
    return apiRequest<{ conversationId: string; conversationReset: boolean }>(
        'financial/assistant/reset',
        { data: { conversationId } },
        'post'
    )
}
